<template>
<v-container class="text-center px-5">
  <v-row>
    <v-col>
      <v-autocomplete
        v-model="category"
        clearable
        hide-no-data
        hide-selected
        label="Category"
        :items="categories"
        @change="categoryChanged"
      />
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-autocomplete
        v-model="tag"
        clearable
        hide-no-data
        hide-selected
        label="Tag"
        :items="tags"
      />
    </v-col>
  </v-row>
</v-container>
</template>

<script>
export default {
  name: "TagFilterBuilder",
  data() {
    return {
      category: "",
      tag: "",
      categories: [],
      tags: [],
    }
  },
  inject: ["httpClient"],
  methods: {
    async categoryChanged() {
      this.tags = []
      if (this.category) {
        this.tags = await this.httpClient.loadTags({
          category: this.category
        })
      } else {
        this.tags = await this.httpClient.loadAllTags()
      }
    },

    async init() {
      this.category = ""
      this.tag = ""
      this.categories = await this.httpClient.loadCategories()
      this.tags = await this.httpClient.loadAllTags()
    },
    build(negate) {
      const prefix = negate ? "not " : ""
      if (this.tag && this.category)
        return [`${prefix}tagged as ${this.tag} under ${this.category}`]
      if (this.tag)
        return [`${prefix}tagged as ${this.tag}`]
      if (this.category)
        return [`${prefix}tagged under ${this.category}`]
      return [null, "You need to select something"]
    }
  }
}
</script>
